import script from "./createRefDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./createRefDocument.vue?vue&type=script&setup=true&lang=ts"

import "./createRefDocument.vue?vue&type=style&index=0&id=6ad40f49&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ad40f49"]])

export default __exports__